class Credentials{
    constructor(uname,pword){
        this.uname=uname;
        this.pword=pword;
    }
}

export default Credentials;